import React, { useRef, useState, useEffect } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { gsap } from 'gsap';
import '../../Atoms/Button/style.css';
import manu from '../../Assets/cms/carousel_img_1-c.webp';
import operator from '../../Assets/cms/Chargepointoperator.png';
import fleet from '../../Assets/cms/OverseeyourEVchargingprocessinrealtime.png';
import enerygyUtils from '../../Assets/cms/Optimizeoperation.png';
import installers from '../../Assets/cms/hardwareindependent.png';
import logo from '../../Assets/icon/logo.svg';
import axios from 'axios';
// import dealership from '../../Assets/find_dealership.webp';
import fleetsolutions from '../../Assets/fleet/new_changes/123 (1).png';
import fleetmobilenetwork from '../../Assets/fleet/mobile_app.png';
import fleetsoftware from '../../Assets/fleet/hero_section (3)-c.dd59ce2e07cdf62a98f3 (1).png';
import fleettechnology from '../../Assets/fleet/new_changes/all product.png';
import fleetsoftwareIcon from '../../Assets/fleet/new_icons/software.png';
import fleetstationIcon from '../../Assets/fleet/new_icons/charging_station.png';
import fleetservicesIcon from '../../Assets/fleet/new_icons/services.png';
import fleetnetworkIcon from '../../Assets/fleet/new_icons/mobile_app.png';
import ReCaptchaV2 from 'react-google-recaptcha';
import fleetcaricon from '../../Assets/fleet/fleet_vehicles/electric/new_changes/new_icons/blur_remove/image__13_-removebg-preview-removebg-preview (1).png';
import fleetlogisticsicon from '../../Assets/fleet/fleet_vehicles/electric/new_changes/new_icons/blur_remove/image__16_-removebg-preview-removebg-preview.png';
import fleetbusicon from '../../Assets/fleet/fleet_vehicles/electric/new_changes/new_icons/blur_remove/image__15_-removebg-preview.png';

import vmbrochure from '../../Assets/fleet/pdf/vm profile.pdf';
import cmsbrochure from '../../Assets/fleet/pdf/cmssoftware.pdf';

import amul from '../../Assets/icon/Amul-c.webp';
import panasonic from '../../Assets/icon/Panasonic-c.png';
import bseb from '../../Assets/icon/BSES-c.webp';
import Madhuban from '../../Assets/icon/Madhuban-c.webp';
import { VerdeLogo } from '../../Atoms';

import { Fade } from 'react-awesome-reveal';
import '../../Atoms/Button/style.css';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
// import Carousel from './Carousal';
import FAQSection from './faqs/faqsection';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StepperModal from './StepperModal';
import { Button } from '../../Atoms/Button';
import { useNavigate } from 'react-router-dom';
import mobileMockup from '../../Assets/become_distributor/mobile_mockup-c.webp';
import cmsMockup from '../../Assets/become_distributor/cms-c.webp';
import ConnectWithUs from '../CPOs/connectWithUs';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';



export default function Chargingprogram() {
  const navigate = useNavigate();
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const solutions = [
    { label: "Stations", title: "Explore Our Stations", number: fleetstationIcon, id: 'stations', },
    { label: "Software", title: "Explore Our Software", number: fleetsoftwareIcon, id: 'software', },
    { label: "Services", title: "Explore Our Services", number: fleetservicesIcon, id: 'services', },
  ];

  const partners = [
    {
      src: amul,
    },
    {
      src: bseb,
    },
    {
      src: Madhuban,
    },
    {
      src: panasonic,
    },
  ];

  const businessCarousel = [
    {
      src: operator,
      head: 'Charge Point Operators',
      desc: 'Offering a world-class charging experience to our fleet partners. VerdeMobility’s Charging Management Software is here to expand your bouquet of service offerings.',
    },
    {
      src: enerygyUtils,
      head: 'Energy Utilities',
      desc: 'Enhance your EV Charging Operations by offering the convenience of tracking and management to your business clients using our intuitive dashboard.',
    },
    {
      src: fleet,
      head: 'Fleet Operators',
      desc: 'Manage all the nitty gritties of your fleet’s charging needs with an easy-to-use and fully-featured Charging Management Software.',
    },
    {
      src: installers,
      head: 'Charge Point Installers',
      desc: 'Offer your business clients the liberty to manage their payments, charging operations, and day-to-day reports with VerdeMobility’s CMS.',
    },
    {
      src: manu,
      head: 'Charge Point Manufactures',
      desc: 'Gain a competitive edge by providing the best of both worlds! Couple your hardware offerings with an intelligent software solution that makes your charging operations easier and efficient.',
    },
  ];

  const fleetData = [
    { image: fleetcaricon, title: 'EV Taxi' },
    { image: fleetlogisticsicon, title: 'Delivery & Logistics' },
    { image: fleetbusicon, title: 'Passenger Transportation' },
    { image: fleetcaricon, title: 'Company cars fleets' },
    // { image: fleetcarpools, title: 'Company Cars Pools' },
  ];

  const [idx, setIdx] = useState(0);
  const imgRef = useRef(null);
  const [modalSource, setModalSource] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formType, setFormType] = useState(''); // "email" or "demo"

  // Form Fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    phone: '',
    notes: '',
  });
  const [modalHeading, setModalHeading] = useState('');
  // Error State
  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);

  // Your reCAPTCHA Site Key
  const RECAPTCHA_SITE_KEY = '6LdwRAArAAAAAOc9Sxvr3IPNP6YbMaToGGQLnZAz';

  const moveNext = () => {
    setIdx((prev) => {
      if (prev === businessCarousel.length - 1) {
        return 0;
      } else {
        return Math.min(businessCarousel.length - 1, prev + 1);
      }
    });
  };
  const movePrev = () => {
    setIdx((prev) => {
      if (prev === 0) {
        return businessCarousel.length - 1;
      } else {
        return Math.max(0, prev - 1);
      }
    });
  };
  const exitAnim = (node) => {
    gsap.to(node, {
      duration: 0.5,
      opacity: 0.3,
    });
  };

  const enter = (node) => {
    gsap.fromTo(
      node,
      {
        opacity: 0.1,
      },
      {
        duration: 0.5,
        opacity: 1,
      }
    );
  };

  const [isStepperModalOpen, setIsStepperModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleClick = () => {
    if (isMobile) {
      window.open(`${window.location.origin}/stepper/index.html`, '_blank'); // Open in a new tab on mobile
    } else {
      setIsStepperModalOpen(true); // Open modal on desktop
    }
  };

  // Open modal with the correct form
  const openModal = (type, source = '', heading) => {
    setFormType(type);
    setModalSource(source);
    setModalHeading(heading);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      name: '',
      email: '',
      organization: '',
      phone: '',
      notes: '',
    });
    setErrors({});
    setCaptchaToken(null);
    // captchaRef.current?.reset();
  };

  // Handle reCAPTCHA
  const handleCaptchaChange = (token) => setCaptchaToken(token);
  const handleCaptchaExpire = () => {
    setCaptchaToken(null);
    setTimeout(() => {
      if (captchaRef.current) {
        captchaRef.current.reset();
      }
    }, 500);
    toast.warning('reCAPTCHA expired! Please verify again.');
  };

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    // Email Validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!emailPattern.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    // Validation

    if (!formData.name.trim()) newErrors.name = 'Name is required.';
    if (!formData.organization.trim())
      newErrors.organization = 'Organization is required.';
    if (!formData.phone.trim() || !/^\d{6,15}$/.test(formData.phone))
      newErrors.phone = 'Phone number should be more than 8 digits.';
    if (!formData.notes.trim()) newErrors.notes = 'Notes are required.';

    if (!formData.email.trim()) newErrors.email = 'Email is required.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Extract username from email
    const username = formData.email.split('@')[0];

    // Construct the full request data
    const requestData = {
      name: formData.name,
      email: formData.email,
      username: username,
      organization: formData.organization,
      phone: formData.phone,
      notes: formData.notes,
      heading: modalHeading,
    };

    try {
      //  Choose the correct API endpoint based on form type
      const endpoint = 'https://mailservice.verdemobility.com/api/Email/request-demo';

      //  Send request to backend
      await axios.post(endpoint, requestData, {
        headers: {
          Authorization: `Bearer ${captchaToken}`, // Send reCAPTCHA token in the header
        },
      });

      //  Show success toast
      toast.success(`User form submitted successfully!`, {
        position: 'top-right',
        autoClose: 1000,
      });

      closeModal();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to submit request. Try again later.');
    }
  };

  return (
    <>
      {/* Toast Notification Container */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Online Infrastracture Estimate */}
      {/* <section className="bg-light-gradient blade-margin">
        <section className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="flex flex-col items-start justify-center gap-5">
              <h3 className="font-gilroylight">
                <strong>Online Infrastracture Estimate</strong>
              </h3>
              <p className="font-poppins font-light pt-2  md:pt-6">
                Estimate your EV charging infrastructure procurement and
                installation costs.
              </p>
            </div>

            <div className="flex justify-start md:justify-center">
              <button
                onClick={handleClick}
                className="btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 py-3 text-sm md:text-base lg:text-lg"
              >
                <span className="flex justify-center items-center">
                  <IoChevronForwardOutline className="h-5 w-6 ioArrow" />
                  <BsArrowRightShort className="h-7 w-7 tailArrow" />
                </span>
                Get Started
              </button>
            </div>
          </div>
        </section>
      </section> */}

      {/* All Sections */}
      {/* <section className="bg-light-gradient blade-margin blade-padding"> */}
      {/* <section className="bg-light-gradient blade-margin">
        <section className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto">
          <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
            <h3 className="text-center font-gilroy">
              Everything you need to keep your EV fleet running at its best
            </h3>
            <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
              Discover how our solutions can optimize your fleet, power your
              stations, and streamline services
            </p>
          </div> */}

      {/* Container for horizontal cards */}
      {/* <div className="flex flex-wrap justify-center gap-12 mt-10">            
            {[
              {
                id: 'stations',
                icon: fleetstationIcon,
                title: 'STATIONS',
                description: 'Explore Our Stations',
              },
              {
                id: 'software',
                icon: fleetsoftwareIcon,
                title: 'SOFTWARE',
                description: 'Explore Our Software',
              },
              {
                id: 'services',
                icon: fleetservicesIcon,
                title: 'SERVICES',
                description: 'Explore Our Services',
              },
            ].map(({ id, icon, title, description }) => (
              <div
                key={id}
                className="card basis-72 max-w-sm h-fit md:h-[16rem] xl:h-[20rem] 2xl:h-[22rem] p-5 grow shrink flex flex-col flex-nowrap gap-4 md:gap-2 self-stretch justify-center items-center group cursor-pointer hover:bg-gradient border border-bgGreen"
                onClick={() => scrollToSection(id)}
              >
                <div>
                  <img
                    loading="lazy"
                    src={icon}
                    alt=""
                    className="md:group-hover:h-0 md:h-24 object-contain w-32 md:group-hover:opacity-0 transition-all duration-500"                  
                  />
                </div>
                <h4 className="card-title-sm font-poppins font-medium">
                  {title}
                </h4>
                <div className="overflow-hidden md:h-0 md:group-hover:h-56 transition-all duration-500">
                  <span className="lg:text-lg text-base font-poppins translate-y-full group-hover:translate-y-0 transition-all duration-500">
                    {description}
                  </span>
                </div>
                <div className="group-hover:rotate-90 transition-all duration-500 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 48 48"
                  >
                    <g fill="none" stroke="#000" strokeWidth="2">
                      <circle cx="24" cy="24" r="24"></circle>
                      <circle cx="24" cy="24" r="23"></circle>
                      <g
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="rotate(45 -4.798 36.575)"
                      >
                        <path d="M0 14.788L14.788 0"></path>
                        <path d="M0 0h14.788v14.788"></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            ))}
          </div> */}

      {/* <div className="space-y-4 mb-8">
            {Array.from({ length: Math.ceil(solutions.length / 2) }).map((_, rowIndex) => {
              const first = solutions[rowIndex * 2];
              const second = solutions[rowIndex * 2 + 1];
              const isSingle = !second;

              const renderCard = (item) => (
                <div
                  className={`bg-gray-200 p-8 rounded-xl flex items-center justify-between font-semibold text-left cursor-pointer`}
                  style={{ flex: isSingle ? "1 1 100%" : "1 1 50%" }}
                  onClick={() => scrollToSection(item.id)}
                >
                  <div className="flex flex-col space-y-2">
                    <span className="text-2xl font-semibold mb-2">{item.label}</span>                    
                        <span className="text-gray-600 text-lg">{item.title}</span>
                  </div>                  
                  <img
                    loading="lazy"
                    src={item.number}
                    alt=""
                    className="h-14 object-contain md:group-hover:opacity-0 transition-all duration-500"                  
                  />
                </div>
              );

              return (
                <div key={rowIndex} className="flex flex-col sm:flex-row gap-4">
                  {renderCard(first)}
                  {second && renderCard(second)}
                </div>
              );
            })}
          </div>
        </section>
      </section> */}

      {/* Solutions built for Business */}
      {/* <section className="bg-light-gradient blade-margin">
        
        <div className="containers-min mx-auto">
          <div className="mx-auto flex flex-col ">
            <Fade bottom>
              <h4 className="font-gilroylight text-center">
                <strong>Solutions built for Business</strong>
              </h4>
              <p className="font-poppins font-light pt-2 md:pt-6 mb-4 text-center">
                Discover how our solutions can optimize your fleet, power your
                stations, and streamline services
              </p>
            </Fade>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 px-3 max-w-screen-xxl mx-auto md:mt-20 mt-10">
            {fleetData.map((fleet, index) => (
              <div
                key={index}
                className="relative flex flex-col self-stretch grow shrink mx-auto rounded-2xl overflow-hidden group"
              >
                <div className="h-[100px] lg:h-[89px] xl:h-[124px] overflow-hidden">
                  <img
                    loading="lazy"
                    src={fleet.image}
                    alt={fleet.title}
                    className="h-full w-full object-cover object-center"
                  />
                </div>

                
                <div className="md:py-3 text-xl lg:text-2xl xxl:text-3xl font-gilroylight  text-center">
                  <span className="text-xl font-bold">{fleet.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Unmatched solutions built on experience */}
      {/* <section className="bg-light-gradient blade-margin">
        <section className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto grid grid-cols-1 grid-rows-2 md:grid-cols-9 md:grid-rows-1">
          
          <div className="row-start-1 row-end-2 lg:row-start-1 col-start-1 lg:col-start-1 lg:col-end-5 col-end-10 bg-green xl:h-[40rem] lg:h-[34rem] h-[24rem]">
            <img
              loading="lazy"
              src={fleetsolutions}
              className="object-cover object-center h-full w-full"
              alt="dealership"
            />
          </div>

          
          <div className="row-start-2 lg:row-start-1 row-end-3 lg:row-end-2 col-start-1 col-end-10 lg:col-start-6 py-5 md:py-10 flex flex-col items-start justify-center gap-3">
            <h3 className="font-gilroylight">
              <strong> Unmatched solutions built on experience</strong>
            </h3>
            <p className="font-poppins font-light pt-2 md:pt-6 mb-4">
              See how our EV Fleet Charging Solution help you reduce cost, ease
              complexity and optimize operations
            </p>

            <div className="flex flex-wrap md:flex-nowrap gap-6 md:gap-10 items-start md:items-center pt-5 md:pt-8 lg:pt-14">
              <a href={vmbrochure} target="_blank" rel="noopener noreferrer">
                <button className="btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6">
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Download Brochure
                </button>
              </a>

              <button
                onClick={() =>
                  openModal(
                    'demo',
                    'getafreeassessment',
                    'Get a Free Assessment'
                  )
                }
                id="getafreeassessment"
                className="btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6"
              >
                <span className="flex justify-center items-center">
                  <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                  <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                </span>
                Get a Free Assessment
              </button>
            </div>
          </div>
        </section>
      </section> */}

      {/* Get powerful software | Discover Software */}
      <section className="bg-light-gradient blade-margin" id="stations">
        <section className="max-w-screen-xl  w-11/12 md:w-10/12 mx-auto grid grid-cols-1 grid-rows-2 md:grid-cols-9 md:grid-rows-1">
          <div className=" row-start-2  lg:row-start-1  row-end-3 lg:row-end-2 col-start-1 col-end-10 lg:col-end-5  py-5 md:py-10 flex flex-col items-start justify-center gap-3">
            {/* <h5 className="mb-2 font-gilroy text-green font-semibold">
              Get software
            </h5> */}
            <div className=" md:pb-8 pb-0">
              <h3 className="text-start font-gilroy">
                Explore VerdeMobility’s EV Fleet Charging Stations
              </h3>
              <p className="my-3 text-start font-poppins font-light">
                We deliver everything you need to power your fleet, from AC to DC
                fast charging
              </p>
            </div>
            {/* <ul className="list-disc pl-5 font-poppins font-light text-lg md:text-xl mt-4">
              <li>Monitor stations in real time.</li>
              <li>Automate charging and control energy costs.</li>
              <li>
                Manage your vehicles without guesswork and make informed
                decisions with EV telematics.
              </li>
              <li>
                Get all the tools you need to manage your EV fleet and increase
                efficiency from one seamless interface.
              </li>
            </ul> */}
            <div className='group cursor-pointer'>
              <a href={vmbrochure} target="_blank" className='text-gray-600'>
                <button
                  className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                >
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Discover Our Charging Stations
                </button>
              </a>
            </div>
            {/* <div className="flex  flex-wrap md:flex-nowrap   gap-6 md:gap-10 items-start md:items-center pt-5 md:pt-8 lg:pt-14">
              <a href={vmbrochure} target="_blank" rel="noopener noreferrer">
                <button
                  className={` btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6`}
                >
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Discover Our Charging Stations
                </button>
              </a>
            </div> */}
          </div>
          <div className="row-start-1 row-end-2 lg:row-start-1 col-start-1 lg:col-start-6 col-end-10  xl:h-[40rem] lg:h-[34rem] h-[24rem] ">
            <img
              loading="lazy"
              // src={fleetsoftware}
              src={fleettechnology}
              className="object-cover object-center h-full w-full"
              alt="dealership"
            />
          </div>
        </section>
      </section>

      {/* Explore VerdeMobility’s EV Fleet Charging Stations | Discover Stations */}
      {/* <section className="bg-light-gradient blade-margin" id="software">
        <section className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto grid grid-cols-1 grid-rows-2 md:grid-cols-9 md:grid-rows-1">
          
          <div className="row-start-1 row-end-2 lg:row-start-1 col-start-1 lg:col-start-1 lg:col-end-5 col-end-10  xl:h-[40rem] lg:h-[34rem] h-[24rem]">
            <img
              loading="lazy"
              src={fleetsoftware}
              className="object-cover object-center h-full w-full"
              alt="dealership"
            />
          </div>

          
          <div className="row-start-2 lg:row-start-1 row-end-3 lg:row-end-2 col-start-1 col-end-10 lg:col-start-6 py-5 md:py-10 flex flex-col items-start justify-center gap-3">
            <div className=" md:pb-8 pb-0">
              <h3 className="text-start font-gilroy">
                Get powerful software for fleet management
              </h3>
              <p className="my-3 md:my-5 lg:my-7 text-start font-poppins font-light">
                Use our integrated software to streamline fleet operations and
                deliver lower total cost of ownership
              </p>
            </div>  

            <div className="flex flex-wrap md:flex-nowrap gap-6 md:gap-10 items-start md:items-center pt-5 md:pt-8 lg:pt-14">
              <a href={cmsbrochure} target="_blank" rel="noopener noreferrer">
                <button className="btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6">
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Discover Our Software
                </button>
              </a>

              <button
                onClick={() => openModal('demo', '', 'Get a Demo')}
                id="demodiv"
                className={` btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6`}
              >
                <span className="flex justify-center items-center">
                  <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                  <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                </span>
                Get a Demo
              </button>
            </div>
          </div>
        </section>
      </section> */}
      <section className="flex max-w-screen-xl my-7 lg:h-[30rem] xl:h-[35rem] md:mx-auto mx-3  lg:flex-row flex-col gap-7 md:w-10/12" id="software">
        <div className=" basis-[24rem] sm:basis-[28rem] lg:basis-96 grow shrink flex flex-col gap-5 items-center py-10 justify-start text-center bg rounded-3xl overflow-hidden bg-grey   relative">
          <span className="text-lg text-green font-poppins font-light">
            SOFTWARE SOLUTIONS
          </span>
          <span className="card-title font-gilroy font-semibold px-2">
            VerdeMobility EV Life App
          </span>

          <div
            onClick={() => navigate('/mobile-app')}
          >
            <button
              className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
            >
              <span className="flex justify-center items-center">
                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
              </span>
              Learn More
            </button>
          </div>
          <img
            loading="lazy"
            src={mobileMockup}
            className="absolute  lg:h-fit sm:h-[15rem] h-[12rem] top-auto bottom-0 object-bottom object-contain lg:max-w-fit max-w-sm w-11/12 md:w-8/12 xxl:w-11/12 "
            alt="mobile screens representing mobile app mockup"
          />
        </div>
        <div className="  basis-[24rem] sm:basis-[28rem] lg:basis-96 grow shrink flex flex-col gap-5 items-center py-10 justify-start text-center bg rounded-3xl overflow-hidden px-3 bg-grey relative ">
          <span className="text-lg text-green font-poppins font-light">
            SOFTWARE SOLUTIONS
          </span>
          <span className="card-title font-gilroy font-semibold">
            VerdeMobility CMS
          </span>
          <div
            onClick={() => navigate('/cms')}
          >
            <button
              className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
            >
              <span className="flex justify-center items-center">
                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
              </span>
              Learn More
            </button>
          </div>
          <img
            loading="lazy"
            className="absolute  lg:h-fit sm:h-[15rem] h-[12rem] top-auto bottom-0 object-bottom object-contain lg:max-w-fit max-w-sm w-11/12 md:w-8/12  xxl:w-8/12"
            src={cmsMockup}
            alt="mobile screens representing mobile app mockup"
          />
        </div>
      </section>

      {/* Count on charging anywhere  */}
      {/* <section className="bg-light-gradient blade-margin  " id="network">
        <section className="max-w-screen-xl  w-11/12 md:w-10/12 mx-auto grid grid-cols-1 grid-rows-2 md:grid-cols-9 md:grid-rows-1">
          <div className=" row-start-2  lg:row-start-1  row-end-3 lg:row-end-2 col-start-1 col-end-10  lg:col-end-5  py-5 md:py-10 flex flex-col items-start justify-center gap-3">
            
            <h3 className="font-gilroylight">
              <strong>Count on charging anywhere</strong>
            </h3>
            <p className="font-poppins font-light pt-2 md:pt-6 mb-4">
              <strong> Verdemobility is the largest EV charging network</strong>{' '}
              for businesses, fleets and drivers
            </p>
           

            <div className="flex  flex-wrap md:flex-nowrap   gap-6 md:gap-10 items-start md:items-center pt-5 md:pt-8 lg:pt-14">
              <a href={vmbrochure} target="_blank" rel="noopener noreferrer">
                <button
                  className={` btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6`}
                >
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Discover Our Network
                </button>
              </a>
            </div>
          </div>

          <div className="row-start-1 row-end-2 lg:row-start-1 col-start-1 lg:col-start-6 col-end-10 xl:h-[40rem] lg:h-[34rem] h-[24rem] ">
            <img
              loading="lazy"
              src={fleetmobilenetwork}
              className="object-cover object-center h-full mx-auto"
              alt="dealership"
            />
          </div>
        </section>
      </section> */}

      {/* Ease your transition to e-mobility with expert services | Discover Services */}
      {/* <Carousel /> */}
      <section className="bg-light-gradient blade-margin" id="services">
        <div className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto">
          <div className=" md:pb-8 pb-0">
            <h3 className="text-center font-gilroy">
              Leverage the power of an end-to-end solution
            </h3>
            <p className="my-3 text-center font-poppins font-light">
              Ease your transition to e-mobility with expert services
            </p>
          </div>
        </div>
        <section className="xl:mt-8 lg:mt-10 mt-4">
          <section className="md:border-[12px]  border-black md:rounded-[50px] md:h-[30rem] lg:h-[38rem]  overflow-hidden  md:w-11/12 lg:w-10/12 max-w-6xl mx-auto flex flex-nowrap md:flex-row flex-col ">
            <div className="flex px-5 grow-[2] basis-52  shrink bg-white h-full">
              <div className="w-full">
                <div className="xl:pl-7 pt-10 pb-2">
                  <img
                    loading="lazy"
                    src={logo}
                    className=" h-5 md:h-8"
                    alt="verdemobility"
                  />
                </div>
                <SwitchTransition>
                  <Transition
                    appear={true}
                    timeout={500}
                    in={true}
                    key={idx}
                    onExit={exitAnim}
                    onEnter={enter}
                    mountOnEnter
                    unmountOnExit
                  >
                    <div className="flex flex-col justify-center gap-1 md:gap-3 max-w-md mx-auto pt-4 xl:mt-10 mt-0">
                      <span className="card-title font-poppins font-medium">
                        {businessCarousel[idx].head}
                      </span>
                      <h5 className="font-poppins font-light">
                        {businessCarousel[idx].desc}
                      </h5>
                    </div>
                  </Transition>
                </SwitchTransition>
              </div>
            </div>
            <div className="flex basis-[29rem] md:basis-[26rem] lg:basis-[28rem] grow-0 shrink h-full md:mt-0 mt-3">
              <SwitchTransition>
                <Transition
                  appear={true}
                  timeout={300}
                  in={true}
                  key={idx}
                  onExit={exitAnim}
                  onEnter={enter}
                  mountOnEnter
                  unmountOnExit
                >
                  <div className="md:h-full md:max-w-full max-w-sm mx-auto h-[24rem] w-full relative">
                    <div className="w-64 md:flex hidden item-center justify-center gap-5 py-4 flex-nowrap absolute -left-32 bottom-0">
                      <button
                        onClick={movePrev}
                        className=" hover:bg-green stroke-white bg-black  mt-1  rounded-full grid p-3 transition-colors duration-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10"
                          fill="inherit"
                          viewBox="0 0 24 24"
                          stroke="inherit"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11 17l-5-5m0 0l5-5m-5 5h12"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={moveNext}
                        className="stroke-green hover:bg-green hover:stroke-white bg-white  mt-1  rounded-full grid p-3 transition-colors duration-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10"
                          fill="inherit"
                          viewBox="0 0 24 24"
                          stroke="inherit"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                          />
                        </svg>
                      </button>
                    </div>
                    <img
                      loading="lazy"
                      src={businessCarousel[0].src}
                      className={` ${idx === 0 ? '' : 'hidden '
                        } md:h-full sm:h-full  h-96 w-full object-cover object-top`}
                      alt="manu"
                      ref={imgRef}
                    />
                    <img
                      loading="lazy"
                      src={businessCarousel[1].src}
                      className={` ${idx === 1 ? '' : 'hidden '
                        } md:h-full sm:h-full  h-96 w-full object-cover object-top `}

                      alt="operator"
                      ref={imgRef}
                    />
                    <img
                      loading="lazy"
                      src={businessCarousel[2].src}
                      className={` ${idx === 2 ? '' : 'hidden '
                        } md:h-full sm:h-full  h-96 w-full object-cover object-top `}

                      alt="fleet"
                      ref={imgRef}
                    />
                    <img
                      loading="lazy"
                      src={businessCarousel[3].src}
                      className={` ${idx === 3 ? '' : 'hidden '
                        } md:h-full sm:h-full  h-96 w-full object-cover object-top `}

                      alt="enerygyUtils"
                      ref={imgRef}
                    />
                    <img
                      loading="lazy"
                      src={businessCarousel[4].src}
                      className={` ${idx === 4 ? '' : 'hidden '
                        } md:h-full sm:h-full  h-96 w-full object-cover object-top `}

                      alt="installers"
                      ref={imgRef}
                    />
                    <div className="absolute top-full  md:left-1/2 left-auto md:right-auto right-0  md:-translate-x-1/2 md:hidden flex flex-nowrap gap-5 px-5  pt-3">
                      <button
                        onClick={movePrev}
                        className=" hover:bg-green stroke-white bg-black  mt-1  place-content-center  md:h-14 md:w-14 h-12 w-12 rounded-full grid p-1   transition-colors duration-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="md:h-10 h-8 md:w-10 w-8"
                          fill="inherit"
                          viewBox="0 0 24 24"
                          stroke="inherit"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11 17l-5-5m0 0l5-5m-5 5h12"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={moveNext}
                        className="stroke-white hover:bg-green  bg-black  mt-1 place-content-center  md:h-14 md:w-14 h-12 w-12 rounded-full grid p-1  transition-colors duration-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="md:h-10 h-8 md:w-10 w-8"
                          fill="inherit"
                          viewBox="0 0 24 24"
                          stroke="inherit"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </Transition>
              </SwitchTransition>
              <div></div>
            </div>
          </section>
        </section>
      </section>

      <ConnectWithUs />

      {/* Unmatched solutions built on experience */}
      <section className="bg-light-gradient blade-margin">
        <section className="max-w-screen-xl w-11/12 md:w-10/12 mx-auto grid grid-cols-1 grid-rows-2 md:grid-cols-9 md:grid-rows-1">

          <div className="row-start-1 row-end-2 lg:row-start-1 col-start-1 lg:col-start-1 lg:col-end-5 col-end-10 bg-green xl:h-[40rem] lg:h-[34rem] h-[24rem]">
            <img
              loading="lazy"
              src={fleetsolutions}
              className="object-cover object-center h-full w-full"
              alt="dealership"
            />
          </div>


          <div className="row-start-2 lg:row-start-1 row-end-3 lg:row-end-2 col-start-1 col-end-10 lg:col-start-6 py-5 md:py-10 flex flex-col items-start justify-center gap-3">
            <div className=" md:pb-8 pb-0">
              <h3 className="text-start font-gilroy">
                Unmatched solutions built on experience
              </h3>
              <p className="my-3 text-start font-poppins font-light">
                See how our EV Fleet Charging Solution help you reduce cost, ease
                complexity and optimize operations
              </p>
            </div>


            <div className="flex flex-wrap md:flex-nowrap gap-6 md:gap-10 items-start md:items-center pt-5 md:pt-8 lg:pt-14">
              <div className='group cursor-pointer'>
                <a href={vmbrochure} target="_blank" className='text-gray-600'>
                  <button
                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                  >
                    <span className="flex justify-center items-center">
                      <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                      <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                    </span>
                    Download Brochure
                  </button>
                </a>
              </div>

              <div
                onClick={() =>
                  openModal(
                    'demo',
                    'getafreeassessment',
                    'Get a Free Assessment'
                  )
                }
                id="getafreeassessment"
              >
                <button
                  className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                >
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Get a Free Assessment
                </button>
                {/* <Button title="Contact Us" /> */}
              </div>
              {/* 
              <button
                onClick={() =>
                  openModal(
                    'demo',
                    'getafreeassessment',
                    'Get a Free Assessment'
                  )
                }
                id="getafreeassessment"
                className="btn font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6"
              >
                <span className="flex justify-center items-center">
                  <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                  <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                </span>
                Get a Free Assessment
              </button> */}
            </div>
          </div>
        </section>
      </section>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4"
          onClick={closeModal}
        >
          <div
            className="bg-white p-6 md:p-8 rounded-lg shadow-lg w-full max-w-lg md:max-w-2xl lg:max-w-3xl max-h-screen overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Dynamic Heading */}
            <h2 className="text-xl md:text-2xl font-semibold mb-6 font-gilroylight text-center">
              {formType === 'demo' && modalSource === 'getafreeassessment'
                ? 'Get a Free Assessment'
                : formType === 'demo' && modalSource === 'connectwithanexpert'
                  ? 'Connect with an Expert'
                  : 'Request a Demo'}
            </h2>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
            >
              {/* Demo Form */}
              {formType === 'demo' && (
                <>
                  {/* Name */}
                  <div>
                    {/* <label className="block text-gray-700 text-lg mb-1">
                      Name <span className="text-red-500">*</span>
                    </label> */}
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) => {
                        handleChange(e);
                        setErrors((prev) => ({ ...prev, name: '' }));
                      }}
                      onBlur={() => {
                        if (!formData.name.trim())
                          setErrors((prev) => ({
                            ...prev,
                            name: 'Name is required.',
                          }));
                      }}
                      placeholder="Name *"
                      className={`w-full p-3 border rounded-lg text-lg ${errors.name ? 'border-red-500' : 'border-gray-300'
                        }`}
                    />
                    {errors.name && (
                      <p className="text-red-500 text-lg mt-1">{errors.name}</p>
                    )}
                  </div>

                  {/* Organization */}
                  <div>
                    {/* <label className="block text-gray-700 text-lg mb-1">
                      Organization Name <span className="text-red-500">*</span>
                    </label> */}
                    <input
                      type="text"
                      name="organization"
                      value={formData.organization}
                      onChange={(e) => {
                        handleChange(e);
                        setErrors((prev) => ({ ...prev, organization: '' }));
                      }}
                      onBlur={() => {
                        if (!formData.organization.trim())
                          setErrors((prev) => ({
                            ...prev,
                            organization: 'Organization is required.',
                          }));
                      }}
                      placeholder="Organization *"
                      className={`w-full p-3 border rounded-lg text-lg ${errors.organization
                        ? 'border-red-500'
                        : 'border-gray-300'
                        }`}
                    />
                    {errors.organization && (
                      <p className="text-red-500 text-lg mt-1">
                        {errors.organization}
                      </p>
                    )}
                  </div>
                  {/* Email */}
                  <div>
                    {/* <label className="block text-gray-700 text-lg mb-1">
                      Email <span className="text-red-500">*</span>
                    </label> */}
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => {
                        handleChange(e);
                        setErrors((prev) => ({ ...prev, email: '' }));
                      }}
                      onBlur={() => {
                        if (!formData.email.trim())
                          setErrors((prev) => ({
                            ...prev,
                            email: 'Email is required.',
                          }));
                      }}
                      placeholder="Email *"
                      className={`w-full p-3 border rounded-lg text-lg ${errors.email ? 'border-red-500' : 'border-gray-300'
                        }`}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-lg mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* Phone */}
                  <div>
                    {/* <label className="block text-gray-700 text-lg mb-1">
                      Phone <span className="text-red-500">*</span>
                    </label> */}
                    <PhoneInput
                      country={'us'}
                      value={formData.phone.startsWith('+') ? formData.phone.slice(1) : formData.phone} // remove + for display
                      onChange={(value) => {
                        const fullNumber = '+' + value; // add + for validation

                        setFormData((prev) => ({ ...prev, phone: fullNumber }));

                        if (/^\d{6,15}$/.test(fullNumber)) {
                          setErrors((prev) => ({ ...prev, phone: '' }));
                        } else {
                          setErrors((prev) => ({
                            ...prev,
                            phone:
                              'Please enter a valid international phone number starting with + and 6 to 15 digits.',
                          }));
                        }
                      }}
                      onBlur={() => {
                        if (!formData.phone.trim()) {
                          setErrors((prev) => ({
                            ...prev,
                            phone: 'Phone number is required.',
                          }));
                        } else if (!/^\d{6,15}$/.test(formData.phone)) {
                          setErrors((prev) => ({
                            ...prev,
                            phone:
                              'Please enter a valid international phone number starting with + and 6 to 15 digits.',
                          }));
                        }
                      }}
                      inputProps={{
                        name: 'phone',
                        required: true,
                        placeholder: 'Phone number (e.g. +123456789)',
                      }}
                      containerClass="w-full"
                      inputClass={`!w-full !p-3 !text-lg !h-[52px] !rounded-lg ${errors.phone ? '!border-red-500' : '!border-gray-300'
                        }`}
                    />
                    {errors.phone && (
                      <p className="text-red-500 text-lg mt-1">
                        {errors.phone}
                      </p>
                    )}
                  </div>

                  {/* Notes */}
                  <div className="md:col-span-2">
                    {/* <label className="block text-gray-700 text-lg mb-1">
                      Notes <span className="text-red-500">*</span>
                    </label> */}
                    <textarea
                      name="notes"
                      value={formData.notes}
                      onChange={(e) => {
                        handleChange(e);
                        setErrors((prev) => ({ ...prev, notes: '' }));
                      }}
                      onBlur={() => {
                        if (!formData.notes.trim())
                          setErrors((prev) => ({
                            ...prev,
                            notes: 'Notes are required.',
                          }));
                      }}
                      placeholder="Notes/Additional details *"
                      className={`w-full p-3 border rounded-lg text-lg ${errors.notes ? 'border-red-500' : 'border-gray-300'
                        }`}
                      rows="3"
                    ></textarea>
                    {errors.notes && (
                      <p className="text-red-500 text-lg mt-1">
                        {errors.notes}
                      </p>
                    )}

                    {/* reCAPTCHA */}
                    <div>
                      <ReCaptchaV2
                        sitekey={RECAPTCHA_SITE_KEY}
                        ref={captchaRef}
                        onChange={handleCaptchaChange}
                        onExpired={handleCaptchaExpire}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Buttons */}
              <div className="col-span-1 md:col-span-2 flex justify-end mt-6">
                <button
                  type="button"
                  onClick={closeModal}
                  className="mr-3 px-5 py-3 bg-gray-300 rounded-lg text-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-3 bg-[#03d077] text-white rounded-lg text-lg"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Stepper Modal */}
      {/* <StepperModal
        isOpen={isStepperModalOpen}
        onClose={() => setIsStepperModalOpen(false)}
      /> */}
      {/* Stepper Modal (Only for Desktop) */}
      {!isMobile && (
        <StepperModal
          isOpen={isStepperModalOpen}
          onClose={() => setIsStepperModalOpen(false)}
        />
      )}
    </>
  );
}
